import api from './api';

const fileUploadService = {
  // Upload File
  uploadFile: async (file, mimeType = 'webp') => {
    const formData = new FormData();
    formData.append('file', file);

    const response = await api.post('/file-upload', formData, {
      params: { mimeType },
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  // Get Signed URL to access object
  getObject: async (filePath) => {
    const response = await api.post('/file-upload/get-object', { filePath });
    return response.data;
  },
};

export default fileUploadService;
